// extracted by mini-css-extract-plugin
module.exports = {"roles":"settings_roles__3J8SJ","leftMargin":"settings_leftMargin__3Amda"};